enum DocumentTypeEnum {
  SALES_AGREEMENT_BUYER = "SALES_AGREEMENT_BUYER",
  SALES_AGREEMENT_SELLER = "SALES_AGREEMENT_SELLER",
  IMAGE = "IMAGE",
  INVOICE = "INVOICE",
  ATTACHMENT = "ATTACHMENT",
  BILL_OF_LADING = "BILL_OF_LADING",
  TRANSPORT_LABEL = "TRANSPORT_LABEL",
  EXPORT_DOCUMENT = "EXPORT_DOCUMENT",
  SALES_RECEIPT = "SALES_RECEIPT",
  INVOICE_DEVIATION = "INVOICE_DEVIATION",
  WEIGHT_REPORT = "WEIGHT_REPORT",
}

export default DocumentTypeEnum;
